export function favorites(state: object = {isSubmitting: false, success: false, error: ''}, action: any) {
    switch (action.type) {
        case 'SUBMITTING_FAVORITES':
            return {...state, isSubmitting: action.data}

        case 'SUBMIT_FAVORITES_SUCCESS':
            return {...state, success: action.data}

        case 'SUBMIT_FAVORITES_ERROR':
            return {...state, error: action.data}

        default:
            return state
    }
}

export function reports(state: object = {fetching: false, entities: {}, error: ''}, action: any) {
    switch (action.type) {
        case 'FETCHING_REPORTS':
            return {...state, fetching: action.data}

        case 'FETCH_REPORTS_SUCCESS':
            return {...state, entities: action.data}

        case 'FETCH_REPORTS_ERROR':
            return {...state, error: action.data}

        default:
            return state
    }
}

export function getSubscribes(state: object = {fetching: false, entities: [], error: ''}, action: any) {
    switch (action.type) {
        case 'FETCHING_SUBSCRIBES':
            return {...state, fetching: action.data}

        case 'FETCH_SUBSCRIBES_SUCCESS':
            return {...state, entities: action.data}

        case 'FETCH_SUBSCRIBES_ERROR':
            return {...state, error: action.data}

        default:
            return state
    }
}

export function updateSubscribes(state: object = {submitting: false, entities: {}, error: ''}, action: any) {
    switch (action.type) {
        case 'SUBMITTING_SUBSCRIBES':
            return {...state, fetching: action.data}

        case 'SUBMIT_SUBSCRIBES_SUCCESS':
            return {...state, entities: action.data}

        case 'SUBMIT_SUBSCRIBES_ERROR':
            return {...state, error: action.data}

        default:
            return state
    }
}

export function newReport(state: object = {}, action: any) {
    switch (action.type) {
        case 'NEW_REPORT':
            return action.data

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Article/reducers.tsx